import React from 'react';
import PropTypes from 'prop-types';
import isIE11 from 'utils/isIE11';
import { Router, Location } from '@reach/router';
import { withStyles } from 'theme/withStyles';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const styles = {
  '@global': {
    '.router.enter': {
      marginRight: '-75%',
      opacity: 0,
    },
    '.router.enter-active': {
      marginRight: 0,
      opacity: 1,
      transition: 'margin 0.3s ease-in-out, opacity 0.3s ease-in-out',
    },
    '.router.exit': {
      display: 'none',
    },
  },
};

const AnimatedRouter = ({ children }) => (
  <Location>
    {({ location = '/oao/start' }) =>
      !isIE11 ? (
        <TransitionGroup>
          <CSSTransition
            key={location.key}
            timeout={{
              enter: 500,
              exit: 0,
            }}
            className="router"
          >
            <Router location={location} basepath="oao" primary={false}>
              {children}
            </Router>
          </CSSTransition>
        </TransitionGroup>
      ) : (
        <div className="router">
          <Router location={location} basepath="oao" primary={false}>
            {children}
          </Router>
        </div>
      )
    }
  </Location>
);

AnimatedRouter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(AnimatedRouter);
